"use client";
import { MiniKitProvider } from "@coinbase/onchainkit/minikit";
import { ReactNode } from "react";
import { baseSep, baseWithFallback } from "@shared/src/config/chains";
import { useHostStore } from "../stores/useHostStore";
import { Chain } from "viem";

export function MiniKitContextProvider({ children }: { children: ReactNode }) {
  const env = useHostStore(state => state.sdk?.env);
  const chain = env === "mainnet" ? baseWithFallback : baseSep;
  return (
    <MiniKitProvider apiKey={process.env.NEXT_PUBLIC_CDP_CLIENT_API_KEY} chain={chain as any}>
      {children}
    </MiniKitProvider>
  );
}
